/** The typed, user-facing terminal sent when a model hit its output cap. */
export const OUTPUT_TRUNCATED_ERROR_CODE = "llm_route_output_truncated";
export const OUTPUT_TRUNCATED_NOTICE_KEY = "_ida_output_truncated_notice";

export function appendOutputTruncationNotice(
  content: string,
  notice: string,
): string {
  return content ? `${content}\n\n${notice}` : notice;
}
